<template>
  <header class="header">
    <div class="header-top">
      <div class="inner">
        <div class="header-left">
          <p class="site-title">
            <img
              src="@/assets/images/TDSDC/logo_tatsuzin.png"
              width="88"
              height="21"
              alt="TATSUZIN"
              @click="$redirect({ name: 'STFMFM01C01' })"
            />
          </p>
        </div>
        <div class="header-left" v-show="trial">
          <span  style="font-size: 1.3rem;">{{ trialMessage }}</span>
        </div>
        <div class="header-right">
          <div class="data-status">
            <span class="data-label">データ領域の使用状況</span>
            <div class="progress">
              <div
                :class="progressBarColor"
                :style="{ width: `${percentage}%` }"
              ></div>
            </div>
            <span class="data-size">{{ dataSpace }}</span>
          </div>
          <div class="user-menu">
            <button class="btn-user-menu" type="button">
              <span class="btn-user-name">{{ userName }}</span>
              &ensp;様
            </button>
            <div class="user-menu-nav">
              <ul>
                <li>
                  <a href="#" @click="operationGuide">運用ガイド</a>
                </li>
                <li>
                  <a href="#" @click="frequentlyAskedQuestions"
                    >よくあるご質問(FAQ)</a
                  >
                </li>
                <li>
                  <a href="#" @click="logout">ログアウト</a>
                </li>
                <li>
                  <span>Version.{{ version }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-bottom">
      <nav class="global-nav inner">
        <ul>
          <template
            v-if="
              menuflg == '1' ||
              menuflg == '2'
            "
          >
            <li :class="[{ current: menuflg == '1' }, 'menu1']">
              <router-link :to="{ name: 'STDSDC02C01' }"
                >事業者情報</router-link
              >
            </li>
            <li :class="[{ current: menuflg == '2' }, 'menu2']">
              <router-link :to="{ name: 'STFMFM02C01' }"
                >ファイル管理</router-link
              >
            </li>
            <li
              v-if="hasSystemAdminAuthtority"
              :class="[{ current: menuflg == '4' }, 'menu4']"
            >
              <router-link :to="{ name: 'STDSDC05C01' }"
                >セキュリティ管理</router-link
              >
            </li>
          </template>
          <template v-else>
            <li class="menu1">
              <router-link :to="{ name: 'STDSDC02C01' }"
                >事業者情報</router-link
              >
            </li>
            <li class="menu2">
              <router-link :to="{ name: 'STFMFM02C01' }"
                >ファイル管理</router-link
              >
            </li>
            <li :class="[{ current: menuflg == '4' }, 'menu4']" v-if="hasSystemAdminAuthtority">
              <router-link :to="{ name: 'STDSDC05C01' }"
                >セキュリティ管理</router-link
              >
            </li>
          </template>
        </ul>
      </nav>
    </div>
    <LogoutConfirmDialog
      :isShow="isLogoutConfirmDialogShow"
      @confirm="confirm"
      @cancel="cancel"
    ></LogoutConfirmDialog>
  </header>
</template>

<script>
import _ from "lodash";
import { mapMutations,mapState } from "vuex";
import { DATA_USAGE } from "@/util/data.js";
import Common from "@/util/common.js";
import LogoutConfirmDialog from "@/components/LogoutConfirmDialog.vue";
import  { API_Header, API_Signout } from '@/api/Modules/CM04/STDSCM04C00.js'
export default {
  name: "AccountingHeader",
  props: {
    menuflg: {
      type: String,
    },
  },
  components: {
    LogoutConfirmDialog,
  },
  data() {
    return {
      dataSpaceUsed: 0, // データ使用状況現在
      dataSpaceTotal: 0, // データ使用状況最大
      percentage: 0, // データ使用状況
      userName: "", // ログイン者名
      version: 0, // バージョン
      trialVersion: 0, // 体験版
      trialMessage: "",
      isLogoutConfirmDialogShow: false,
      hasSystemAdminAuthtority: false,
    };
  },
  // No8データ容量表示領域更新対応
  watch:{
    dataSpaceUsedChangeFlag(newValue){
      if(newValue){
        this.processDialogue(false);
        this.fetchMaintenance("");
        // ユーザー情報を取得する
        API_Header().then((response) => {
          this.dataSpaceUsed = response.dataSpaceUsed;
          this.dataSpaceTotal = response.dataSpaceTotal;
          this.percentage = _.divide(this.dataSpaceUsed, this.dataSpaceTotal) * 100;
          if (this.percentage > 100) {
            this.percentage = 100;
          }
          this.userName = response.userSigninInfo.userName;
          this.trialVersion = response.userSigninInfo.availableDays;
          this.hasSystemAdminAuthtority =
            response.userSigninInfo.hasSystemAdminAuthtority;
          this.version = response.version;
          if (this.$cookies.get("preOcclusionFlag")) {
            this.setCloseType(response.closeType);
            this.fetchMaintenance(response.maintenance);
          }
          this.updateDataSpaceUsedChangeFlag(false)
        });
      }
    }
  },
  created() {
    this.trialMessage = Common.getMessage("MTCL2073");
  },
  computed: {
    // **********************************************
    // *  プログレス バー
    // **********************************************
    progressBarColor() {
      if (this.dataSpaceTotal === 0 || isNaN(this.dataSpaceTotal)) {
        return "generally";
      } else {
        let color = _.divide(this.dataSpaceUsed, this.dataSpaceTotal);
        // 通常時
        if (color >= 0 && color <= 0.8) {
          return "generally";
          // 80%超え
        } else if (color > 0.8 && color <= 0.9) {
          return "warn";
          // 90%超え
        } else if (color > 0.9) {
          return "full";
        } else {
          return "";
        }
      }
    },
    // **********************************************
    // *  データ使用状況
    // **********************************************
    dataSpace() {
      return this.usageBar(this.dataSpaceUsed, this.dataSpaceTotal);
    },
    // **********************************************
    // *  体験版表示・非表示
    // **********************************************
    trial() {
      return this.trialVersion == 0 ? false : true;
    },
    // No8データ容量表示領域更新対応
    ...mapState("businessModule", {
      dataSpaceUsedChangeFlag:state=>state.dataSpaceUsedChangeFlag
    })
  },
  mounted() {
    this.processDialogue(false);
    this.fetchMaintenance("");
    // ユーザー情報を取得する
    API_Header().then((response) => {
      this.dataSpaceUsed = response.dataSpaceUsed;
      this.dataSpaceTotal = response.dataSpaceTotal;
      this.percentage = _.divide(this.dataSpaceUsed, this.dataSpaceTotal) * 100;
      if (this.percentage > 100) {
        this.percentage = 100;
      }
      this.userName = response.userSigninInfo.userName;
      this.trialVersion = response.userSigninInfo.availableDays;
      this.hasSystemAdminAuthtority =
        response.userSigninInfo.hasSystemAdminAuthtority;
      this.version = response.version;
      if (this.$cookies.get("preOcclusionFlag")) {
        this.setCloseType(response.closeType);
        this.fetchMaintenance(response.maintenance);
      }
    });
  },
  methods: {
    // No8データ容量表示領域更新対応
    ...mapMutations("businessModule", [
      "fetchMaintenance",
      "setCloseType",
      "processDialogue",
      "updateDataSpaceUsedChangeFlag"
    ]),
    // **********************************************
    // * 運用ガイド
    // **********************************************
    operationGuide() {
      window.open(
        Common.getSettingsValue("OperationGuideUrl"),
        "_blank",
        "width=1240,height=760,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no"
      );
    },
    // **********************************************
    // * よくあるご質問(FAQ)
    // **********************************************
    frequentlyAskedQuestions() {
      window.open(
        Common.getSettingsValue("FAQUrl"),
        "_blank",
        "width=1240,height=760,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no"
      );
    },
    // **********************************************
    // * ログアウト
    // **********************************************
    logout() {
      this.isLogoutConfirmDialogShow = true;
    },
    // **********************************************
    // * ステータスバー
    // **********************************************
    usageBar(used, total) {
      let result;
      DATA_USAGE.forEach((el) => {
        if (el[0] === 0) {
          result = `${used}／${total + el[2]}`;
        } else if (el[0] <= total && total <= el[1]) {
          result = `${this.mathRound(used, el[0])}／${this.mathRound(
            total,
            el[0]
          )}${el[2]}`;
        }
      });
      return result;
    },
    // **********************************************
    // * 四捨五入
    // **********************************************
    mathRound(data, number) {
      return Math.trunc(_.divide(data, number));
    },
    // **********************************************
    // * ログアウト確認
    // **********************************************
    confirm() {
      // 遷移チェック：「OK」
      API_Signout()
        .then((response) => {
          console.log("Signout", response);
          // 成功の場合
          if (_.eq(response.result, "0000")) {
            // Sessionクリア
            this.$cookies.remove("SessionID");
            this.$cookies.remove("preOcclusionFlag");
            this.$redirect({ name: "STDSCM01C01" });
          } else {
            this.$router.push({
              name: "STDSCM04C06",
              state: {
                message: "ログアウト失敗",
              },
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.isLogoutConfirmDialogShow = false;
    },
    // **********************************************
    // * ログアウトキャンセル
    // **********************************************
    cancel() {
      // 遷移チェック：「キャンセル」
      this.isLogoutConfirmDialogShow = false;
    },
  },
};
</script>

<style scoped>
.generally {
  background-color: #a6ccfe;
  height: 10px;
}
.warn {
  background-color: #efd069;
  height: 10px;
}
.full {
  background-color: #d63e49;
  height: 10px;
}
</style>
